import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MasterSettingsService } from 'src/app/services/master-settings.service';

@Component({
    selector: 'app-refresh-master-settings',
    templateUrl: './refresh-master-settings.component.html',
    styleUrls: ['./refresh-master-settings.component.scss'],
    standalone: false // NOSONAR
})
export class RefreshMasterSettingsComponent implements OnInit {
  heading: any;
  domicile: string;
  errormsg: any;
  type: string;
  message: string;

  constructor(
    public dialogRef: MatDialogRef<RefreshMasterSettingsComponent>,
     private readonly service : MasterSettingsService,
    @Inject(MAT_DIALOG_DATA) public dataStore: any
  ) {}

  ngOnInit(): void {
    this.heading = this.dataStore.header;

    this.domicile = this.dataStore.params.domicile;
    this.type = this.dataStore.type;
    if (this.type == 'reset') {    // NOSONAR
      this.message = `Confirm reset master settings for domicile: ${this.domicile} to defaults?`;
    } else {
      this.message = `Confirm disable master settings for domicile: ${this.domicile}?`;
    }
  }

  close(): void {
    this.dialogRef.close({ event: 'CloseEvent' });
  }

  resetClick() {
    const params = {
      domicile: this.domicile,
    };
    this.service.resetMasterSettings(params).subscribe({
      next: (_res: any) => {
        this.dialogRef.close({ event: 'objectUpdated', eventType: 'success' });
      },
      error: (error) => {
        this.dialogRef.close({ event: 'objectUpdated', eventType: 'failure' });
        console.info(error);
      },
    });
  }

  deleteClick() {
    const params = {
      domicile: this.domicile,
      updateTrigger: 0,
      redTrigger: 0,
      yellowTrigger: 0,
      snoozeDelay: 0,
    };
    this.service.updateMasterSettings(params).subscribe({
      next: (_res: any) => {
        this.dialogRef.close({ event: 'objectUpdated', eventType: 'success' });
      },
      error: (error) => {
        this.dialogRef.close({ event: 'objectUpdated', eventType: 'failure' });
        console.info(error);
      },
    });
  }
}
